<div class="media-hero">
  <app-video-carousel [solo]="true"></app-video-carousel>

  <a class="button next-button" routerLink="/media">Visit the Media page</a>
</div>
